import RightFloatingShortcuts from '../../../../../components/front/subsidiaries/right-floating-shortcuts';

RightFloatingShortcuts.hideButtonsOnRightSide();
